<template>
  <div class="text-center">
    <v-bottom-sheet v-model="components.bottom_sheet.is_open" persistent inset>
      <v-sheet class="text-center" height="360px" style="background-color:rgb(245,245,220,0.90)">
        <div class="text-right">
          <v-btn
            text
            icon
            @click="closeSheet"
          >
            <v-icon>mdi-arrow-down</v-icon>
          </v-btn>
        </div>
        <div v-if="components.bottom_sheet.option_index==1">
          <MyQuotations />
        </div>
        <div v-else-if="components.bottom_sheet.option_index==2">
          <div class="py-3"><h6>Report an Incident</h6></div>
          
        </div>
        <div v-else-if="components.bottom_sheet.option_index==3">
          <ClaimIntimation />          
        </div>
        <div v-else-if="components.bottom_sheet.option_index==4">
          <Complaints />          
        </div>
        <div v-else-if="components.bottom_sheet.option_index==5">
          <Complaints />          
        </div>
        <div v-else-if="components.bottom_sheet.option_index==6">
          <Benefits />          
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
  
  import { mapGetters } from 'vuex';
  const Benefits = () => import('@/components/Benefits.vue');
  const Complaints = () => import('@/components/Complaints.vue');
  const ClaimIntimation = () => import('@/components/ClaimIntimation.vue');
  const MyQuotations = () => import('@/components/MyQuotations.vue');

  export default {
    data: () => ({
      
    }),
    components: {
      Complaints,
      MyQuotations,
      ClaimIntimation,
      Benefits
    },
    methods: {
      closeSheet(){
        this.components.bottom_sheet.is_open=false;
        this.components.bottom_sheet.option_index=0;
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    }   
  }
</script>